import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { toPng } from 'html-to-image';
import { useTranslation } from 'react-i18next';

const QRCodePopup = ({ isOpen, onClose, url }) => {
  const { t } = useTranslation();
  const qrRef = useRef(null);

  const handleDownload = () => {
    if (qrRef.current === null) return;

    toPng(qrRef.current)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'qr-code.png';
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error(t('qrDownloadFail'), err);
      });
  };

  if (!isOpen || !url) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button style={styles.closeButton} onClick={onClose}>x</button>
        <div ref={qrRef} style={styles.qrContainer}>
          <QRCodeCanvas value={url} size={200} />
        </div>
        <p style={{ marginBottom: 10, textAlign: 'center', 
                    width: '100%', wordBreak: 'break-word' }}>
          {url}
        </p>

        <button onClick={handleDownload} style={styles.downloadButton}>
          {t('qrDownload')}
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center',
    zIndex: 1000,
  },
  popup: {
    background: '#fff', padding: 20, borderRadius: 8,
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    position: 'relative', width: 300,
  },
  qrContainer: {
    marginBottom: 10,
  },
  downloadButton: {
    padding: '10px 20px', fontSize: 16, cursor: 'pointer',
    backgroundColor: '#007bff', color: '#fff', border: 'none',
    borderRadius: '999px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s ease',
  },
  closeButton: {
    position: 'absolute', top: 10, right: 10,
    background: 'transparent', border: 'none', fontSize: 20, cursor: 'pointer',
  }
};

QRCodePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
};

export default QRCodePopup;
